import { render } from "./LabelDateField.vue?vue&type=template&id=9aa9a7be"
import script from "./LabelDateField.vue?vue&type=script&lang=js"
export * from "./LabelDateField.vue?vue&type=script&lang=js"

import "../styles/LabelDateField.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__